import identity from 'lodash.identity'

const arrays = {
  filter: predicate => list => list.filter(predicate),
  some: predicate => list => list.some(predicate)
}

const to = {
  ...arrays,
  trim: str => str.trim(),
  lowerCase: str => str.toLowerCase(),
  upperCase: str => str.toUpperCase(),
  titleCase: ([head, ...tail]) => [to.upperCase(head), ...tail.map(to.lowerCase).filter(identity)].join('')
}

export default to
